import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { environment } from '../../environments/environment';
import { NotificationsService } from 'angular2-notifications';
@Component({
  selector: 'app-sistema-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  mostrarMenuAside: boolean = false;
  mostrarCambiarEmpresa: boolean = false;
  mostrarManual: boolean = false;
  usuario: any = JSON.parse(localStorage.getItem('usuario'));
  configuracion: any = JSON.parse(localStorage.getItem('configuracion'));
  empresa;
  sucursal;
  nivel_educativo;
  API_PATH = environment.API_PATH;
  constructor(private fb: FormBuilder, private notificacion: NotificationsService) { }

  menuactual: string;
  menutitulo: string;
  menuicono: string;
  mostrar = [];
  actilet = false;
  mensaje_cambiar_empresa:string = '';
  activarMenu = false;
  activar     = false;

  ngOnInit() {
    let menu = JSON.parse(localStorage.getItem("menu"));

    let url = location.href.split("/");
    this.menuactual = url[4];
    menu.forEach(element => {
      if(element.path.indexOf(this.menuactual) > -1){
        this.menutitulo = element.titulo;
        this.menuicono = element.icono;
      }
    });

    this.empresa = localStorage.getItem("empresa");
    this.mostrar[this.empresa] = true;
    this.sucursal = localStorage.getItem("sucursal");
    this.nivel_educativo = localStorage.getItem("nivel_educativo");

    let abrir = false;
    if (this.empresa == '' || this.empresa == undefined || this.empresa == null)
      abrir = true;
    else{
      if (this.sucursal == '' || this.sucursal == undefined || this.sucursal == null)
        abrir = true;

      if (this.nivel_educativo == '' || this.nivel_educativo == undefined || this.nivel_educativo == null)
        abrir = true;
    }
    if(abrir){
      this.mensaje_cambiar_empresa = "No se ha seleccionado ninguna empresa o sucursal, Por favor seleccione una y verifique el nivel educativo";
      this.mostrarCambiarEmpresa = true;
    }
    if(this.configuracion.sucursal == undefined){
      this.usuario.empresas.forEach(element => {
        element.sucursales.forEach(ele => {
          if(ele.id == this.sucursal){
            this.configuracion.sucursal = ele;
          }
        });
      });

      localStorage.setItem('configuracion', JSON.stringify(this.configuracion));
    }
    if (this.configuracion.nivel_educativo == undefined) {
      this.usuario.niveles_educativos.forEach(ele => {
        if (ele.id == this.nivel_educativo) {
          this.configuracion.nivel_educativo = ele;
        }
      });

      localStorage.setItem('configuracion', JSON.stringify(this.configuracion));
    }

  }
  toggleMenuAside() {
    this.mostrarMenuAside = !this.mostrarMenuAside;
  }

  toggleCambiarEmpresa() {
    this.mostrarCambiarEmpresa = !this.mostrarCambiarEmpresa;
  }

  toggleManual() {
    this.mostrarManual = !this.mostrarManual;
  }

  cambiar_sucursal(val, item){

    localStorage.setItem('empresa', val.id);
    localStorage.setItem('sucursal', item.id);

    let configuracion = {empresa : '', sucursal : ''};
    configuracion.empresa = val.configuracion;
    localStorage.setItem('configuracion', JSON.stringify(configuracion));

    configuracion.sucursal = item.configuracion;
    localStorage.setItem('configuracion', JSON.stringify(configuracion));

    if(document.getElementById('cargar_datos_actualizar'))
      document.getElementById('cargar_datos_actualizar').click();

    if (document.getElementById('catalogos'))
      document.getElementById('catalogos').click();

    this.empresa = localStorage.getItem("empresa");
    this.sucursal = localStorage.getItem("sucursal");
    this.configuracion = configuracion;
  }

  cambiar_nivel_educativo(item) {

    localStorage.setItem('nivel_educativo', item.id);

    let configuracion = JSON.parse(localStorage.getItem("configuracion"));
    configuracion.nivel_educativo = item;
    localStorage.setItem('configuracion', JSON.stringify(configuracion));

    if (document.getElementById('cargar_datos_actualizar'))
      document.getElementById('cargar_datos_actualizar').click();

    if (document.getElementById('catalogos'))
      document.getElementById('catalogos').click();


    this.nivel_educativo = localStorage.getItem("nivel_educativo");
    this.configuracion = configuracion;
    this.toggleCambiarEmpresa();
  }
}
